'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactUtils = require('react-utils');

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _DatePicker = require('MeetingsLib/components/schedule/date/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _ProfileHeader = require('MeetingsLib/components/header/ProfileHeader');

var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);

var _ColoredCard = require('MeetingsLib/components/decorative/ColoredCard');

var _ColoredCard2 = _interopRequireDefault(_ColoredCard);

var _FreemiumBookingUpgradeLink = require('MeetingsLib/components/freemium/FreemiumBookingUpgradeLink');

var _FreemiumBookingUpgradeLink2 = _interopRequireDefault(_FreemiumBookingUpgradeLink);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerSection = _react2.default.createClass({
  displayName: 'DatePickerSection',

  propTypes: {
    // passed
    avatar: _react.PropTypes.string,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    compact: _react.PropTypes.bool,
    embedded: _react.PropTypes.bool,
    headline: _react.PropTypes.string,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired,
    profile: _react.PropTypes.instanceOf(_UserProfile2.default).isRequired,

    // loaded
    isSalesStarter: _react.PropTypes.bool,
    setEventDate: _react.PropTypes.func.isRequired
  },

  getCardClasses: function getCardClasses() {
    var _props = this.props,
        embedded = _props.embedded,
        isSalesStarter = _props.isSalesStarter;


    return (0, _reactUtils.classNames)('p-top-7 p-bottom-5 height-93', {
      'p-top-13': isSalesStarter,
      'height-100': embedded || isSalesStarter
    });
  },
  renderFreemiumText: function renderFreemiumText() {
    var isSalesStarter = this.props.isSalesStarter;


    if (isSalesStarter) {
      return null;
    }

    return _react2.default.createElement(_FreemiumBookingUpgradeLink2.default, null);
  },
  render: function render() {
    var _props2 = this.props,
        avatar = _props2.avatar,
        branding = _props2.branding,
        compact = _props2.compact,
        headline = _props2.headline,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding,
        profile = _props2.profile,
        setEventDate = _props2.setEventDate;


    return _react2.default.createElement(
      'div',
      { className: 'date-picker-section overflow-y-hidden' },
      _react2.default.createElement(
        _ColoredCard2.default,
        {
          className: this.getCardClasses(),
          branding: branding,
          isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding
        },
        _react2.default.createElement(_ProfileHeader2.default, {
          avatar: avatar,
          booked: false,
          headline: headline,
          profile: profile
        }),
        _react2.default.createElement(_DatePicker2.default, {
          compact: compact,
          profile: profile,
          branding: branding,
          setEventDate: setEventDate
        })
      ),
      this.renderFreemiumText()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isSalesStarter: state.isSalesStarter
  };
}, _extends({}, FormActions))(DatePickerSection);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/sections/DatePickerSection.js
// module id = 213
// module chunks = 0